import { IChapter, ITest } from "./types";

export const QUIZ_DATA: ITest[] = [
  {
    title: "ソーシャルエンジニアリング",
    question:
      "「もしもし？社長の山田ですが、至急社内ネットワークのテストがする必要があるのでパスワードを教えてもらえますか？」で使われているソーシャルエンジニアリングの手法をすべて選べ。",
    description:
      "「社長の山田ですが」はネームドロップで社長という立場の権威を利用、「支給～する必要がある」はハリーアップで相手を急かして正常な判断を出来なくさせています。ギブアンドテイクはメリットの代わりに情報を提供し、フレンドシップは友人のふりまたは友情をもって接する手法です。",
    type: "select-multi",
    answer: ["ネームドロップ", "ハリーアップ"],
    options: [
      "ネームドロップ",
      "ハリーアップ",
      "ギブアンドテイク",
      "フレンドシップ",
    ],
    tags: ["オンライン詐欺"],
  },
  {
    title: "詐欺サイトのURL",
    question: "架空のラッキー銀行にふさわしいURLを選べ。",
    description:
      "正しくないものは大文字のI、数字の1が使われています。詐欺サイトのURLは本物と似たものが多く視認は難しいため、ブラウザのブックマーク機能に公式サイトを追加するのがおすすめです。",
    type: "select-one",
    answer: ["luckybank.co.jp"],
    options: ["Iuckybank.co.jp", "luckybank.co.jp", "1uckybank.co.jp"],
    tags: ["オンライン詐欺"],
  },
  {
    title: "詐欺サイトへの誘導",
    question: "詐欺サイトの誘導に使われる媒体をすべて選べ。",
    description:
      "詐欺サイトへの誘導は今ではメールやソーシャルメディアだけでなく、スマホのゲームアプリのメッセージなども潜んでいます。常に知らない人からのメッセージは警戒するようにしましょう。",
    type: "select-multi",
    answer: ["スマホのゲームアプリ", "メール", "SMS", "ソーシャルメディア"],
    options: ["スマホのゲームアプリ", "メール", "SMS", "ソーシャルメディア"],
    tags: ["オンライン詐欺"],
  },
  {
    title: "標的型メールの対策",
    question: "標的型メールの対策としてふさわしいものを選べ。",
    description:
      "標的型メールは詐欺師が徹底的にパターンを学んでいるため、本物か偽物かが分からないことがあります。差出人を確認したり名前がある場合は本人に返信以外の手段（電話や直接会って聞く等）で確認しましょう。",
    type: "select-multi",
    answer: ["メールを送ってきた本人に確認する", "差出人を確認する"],
    options: [
      "メールを送ってきた本人に確認する",
      "メールに返信して確認する",
      "添付ファイルを開く",
      "差出人を確認する",
    ],
    tags: ["オンライン詐欺"],
  },
  {
    title: "安全なパスワード",
    question: "総当たり攻撃に対して安全圏にあるパスワードをすべて選べ。",
    description:
      "総当たり攻撃とは「AAAAAA」「AAAAAB」のように考えられる組み合わせのパスワードを総当たりする方法です。内閣サイバーセキュリティセンターでは英大文字小文字＋数字＋記号で 10桁以上のパスワードを安全圏としていますが、桁数を増やすことでさらに強化することができます。",
    type: "select-multi",
    answer: ["n1scP@sswaad0"],
    options: ["securepassword", "n1scP@sswaad0", "ka8D@f@j", "hvdkernnld"],
    tags: ["アカウントセキュリティ"],
  },
  {
    title: "秘密の質問",
    question: "秘密の質問「あなたの小学校は？」に対して有効であるものを選べ。",
    description:
      "秘密の質問は本人じゃなくても知られている事実が多くパスワードを知らなくてもリセットまたはログインができてしまうことがあるので真面目に答えてはいけません。また、パスワードと同様に使い回しも避けましょう。",
    type: "select-one",
    answer: ["いちごババロア抹茶風味"],
    options: [
      "安城小学校",
      "いちごババロア抹茶風味",
      "Anjo Elementary School",
      "安城",
    ],
    tags: ["アカウントセキュリティ"],
  },
  {
    title: "パスワード管理とブラウザ",
    question:
      "次回から入力する手間が省けるのでパスワードをブラウザに保存する。",
    description:
      "ブラウザのセキュリティが危険に晒されたらパスワードが流出したり、本人不在の間に勝手に操作する恐れがあります。ブラウザの自動入力機能は確かに便利ですが、パスワード管理アプリや紙のパスワード管理ノートを使いましょう。",
    type: "tf",
    answer: ["誤"],
    tags: ["アカウントセキュリティ"],
  },
  {
    title: "安全なパスワードの管理方法",
    question: "正しいパスワード管理方法をすべて選べ。",
    description:
      "パスワード管理には「端末近くで管理しない」「サーバー上に保存しない（クラウドを利用する場合は評判などを事前に確認する）」「管理する場所（端末や金庫など）をロックする」です。すべて覚えるのは管理方法としては適切ですが、簡単なパスワードや使い回しパスワードを避けるために今一度安全なパスワードであるか確認しましょう。",
    type: "select-multi",
    answer: ["クラウドを経由しないパスワード管理アプリを使う", "すべて覚える"],
    options: [
      "紙に書いたパスワード管理ノートをパソコン横の本棚に置く",
      "ブラウザの自動入力機能を使う",
      "クラウドを経由しないパスワード管理アプリを使う",
      "すべて覚える",
    ],
    tags: ["アカウントセキュリティ"],
  },
  {
    title: "二段階認証",
    question: "この中で危険な二段階認証を選べ。",
    description:
      "ＳＭＳ（ショートメッセージ）を使ったワンタイムパスワード送信はＳＩＭハイジャックという事例があるため認証に使うのは避けましょう。",
    type: "select-one",
    answer: [
      "アプリにログインしたあと、SMS経由でワンタイムパスワードを送信する",
    ],
    options: [
      "キャッシュカードを挿入したあと、暗証番号を入力する",
      "Webサービスにログインしたあと、指紋を入力する",
      "アプリにログインしたあと、SMS経由でワンタイムパスワードを送信する",
      "インターネット銀行にログインしたあと、Google認証システムのワンタイムパスワードを送信する",
    ],
    tags: ["アカウントセキュリティ"],
  },
  {
    title: "スマホのアプリ",
    question:
      "Apple StoreやGoogle Playにあるアプリは認証されているので安心して使うことができる。",
    description:
      "ストア上のアプリはインターネット上にある認証されていないアプリ（野良アプリ）よりは信頼とはいえ危ないアプリは存在します。インストールする前に事前にアプリ名や運営会社を検索し、安全性を確認してから公式サイトからダウンロードしてください。",
    type: "tf",
    answer: ["誤"],
    tags: ["デバイスセキュリティ"],
  },
  {
    title: "スマホの自動画面ロック",
    question: "スマホの画面ロックを自動に行うのに最も適しているものを選べ。",
    description:
      "画面ロックはスマホのパスワードです。複雑で長いパスワードを作り、スマホの自動ロックは常に最も早いものにを選択します。",
    type: "select-one",
    answer: ["すぐ"],
    options: ["すぐ", "1分", "15分", "なし"],
    tags: ["デバイスセキュリティ"],
  },
  {
    title: "ショルダーハック",
    question: "スマホで入力中にショルダーハックの危険があるものをすべて選べ。",
    description:
      "ショルダーハックとは攻撃者が入力中に後ろからのぞいて秘密情報を得る攻撃方法です。これを防ぐためには入力画面を見られないことですが、指紋認証や顔認証などの生体認証が有効です。",
    type: "select-multi",
    answer: ["PINコード", "ワンタイムパスワード"],
    options: ["指紋認証", "PINコード", "ワンタイムパスワード", "顔認証"],
    tags: ["デバイスセキュリティ", "アカウントセキュリティ"],
  },
  {
    title: "HTTPS",
    question:
      "HTTPSは通信が暗号化されていて安全なので、https://から始まるウェブサイトに繋ぐときにSSL証明書を確認する必要はない。",
    description:
      "HTTPSによりサーバーとブラウザ間の暗号通信が保証されていますが、自分で自分を認証するなどSSL証明書をもつサイトの中には安全でないものが混ざっています。特に金融情報の入力が必要な場合は第三者からの審査も厳しく通ったEV-SSL証明書からウェブサイト自体の安全性を確認してください。",
    type: "tf",
    answer: ["誤"],
    tags: ["デバイスセキュリティ", "オンライン詐欺"],
  },
  {
    title: "Wi-Fiルーターの設定",
    question:
      "Wi-Fiルーター購入時の識別名（名前）と暗号キー（パスワード）は長く複雑なので、変える必要はない。",
    description:
      "メーカーによっては規則的で推測可能なパスワードを使っていることもあります。Wi-Fiルーターに限らず、購入したIT機器は初期設定のまま使わないようにしましょう。",
    type: "tf",
    answer: ["誤"],
    tags: ["デバイスセキュリティ"],
  },
  {
    title: "Wi-Fiの暗号化方式",
    question: "この中から安全なものをすべて選べ。",
    description:
      "WEPとWPAの暗号は既に解読済みなので暗号化していないのと同じです。また暗号キーにTSIKはセキュリティ上の不安があるので、より安全なAESを使用してください。",
    type: "select-multi",
    answer: ["WPA2-PSK (AES)"],
    options: ["WEP", "WPA2-PSK (AES)", "WPA", "WPA2-PSK (TSIK)"],
    tags: ["デバイスセキュリティ"],
  },
];

export const DATA: IChapter[] = [
  {
    title: "オンライン詐欺",
    time: 8,
    description:
      "あなたが話している相手は誰ですか？様々なオンライン詐欺が横行する中で本物を見抜くために必要な知識を学びます。",
    url: "online-fraud",
    lectures: [
      {
        title: "オンライン詐欺の基本",
      },
      {
        title: "オンライン詐欺を見抜く",
      },
    ],
  },
  {
    title: "アカウントセキュリティ",
    time: 13,
    description:
      "あなたが普段使っているアカウントは安全ですか？パスワードだけに頼らない安全なアカウント認証などを学びます。",
    url: "account-security",
    lectures: [
      {
        title: "いろいろなアカウント攻撃の方法",
      },
      {
        title: "安全なパスワードの設定と保管方法",
      },
      {
        title: "ログイン方法をもっと安全に",
      },
    ],
  },
  {
    title: "デバイスセキュリティ",
    time: 20,
    description:
      "知らずのうちに情報を漏らしていませんか？ブラウザやネットワークなどを安全に使用する方法を学びます。",
    url: "device-security",
    lectures: [
      {
        title: "デバイスセキュリティ",
      },
      {
        title: "アプリケーションセキュリティ",
      },
      {
        title: "ネットワークセキュリティ",
      },
    ],
  },
];

export const BASE_URL = "https://cytrain.netlify.app";
export const BASE_SHARE_TEXT =
  "セキュリティに不安を感じたことはありませんか？Cytrainで誰でも無料のオンラインセキュリティ研修が受講できます。 #CyTrain";
